var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"skeleton-row"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }